import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;
const baseUrl = `${baseDomain}/api/`;
const resource = 'dashboard';

export default {
    overview() {
        return resources.get(`${resource}/overview`);
    },
    dailyStats() {
        return resources.get(`${resource}/daily-stats`);
    },
    statusBreakdown() {
        return resources.get(`${resource}/status-breakdown`);
    },
}
